export default "__VITE_ASSET__5DuOQQjh__"